module.exports = __webpack_public_path__ + "img/2.1.847a46c9.png";